import { Suspense } from "react";
import { AuthProvider } from "providers/AuthProvider";
import { LoadingProvider } from "providers/LoadingProvider";
import { AlertsProvider } from "providers/AlertProvider";
import { NotificationProvider } from "providers/NotificationProvider";
import { PrimeReactProvider } from "primereact/api";
import { SocketProvider } from "providers/SocketProvider";
// import Tailwind from "primereact/passthrough/tailwind";

type Props = {
  children: JSX.Element;
};

function AppProvider({ children }: Props) {
  return (
    <Suspense>
      <PrimeReactProvider value={{ unstyled: false }}>
        <LoadingProvider>
          <SocketProvider>
            <AlertsProvider>
              <AuthProvider>
                <NotificationProvider>{children}</NotificationProvider>
              </AuthProvider>
            </AlertsProvider>
          </SocketProvider>
        </LoadingProvider>
      </PrimeReactProvider>
    </Suspense>
  );
}

export default AppProvider;
